if (!window.Eurus.loadedScript.has('payment-button.js')) {
  window.Eurus.loadedScript.add('payment-button.js');

  const register = () => {
      Alpine.store('xShopifyPaymentBtn', {
        load(e) {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        },
      });
  };
  if (window.Alpine) register();
  else requestAnimationFrame(() => {
    if (window.Alpine) register();
    else document.addEventListener('alpine:init', register, { once: true });
  });
}
